import {Component, OnInit} from '@angular/core';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {SupplierContact, SupplierContactsService} from "@proleis/proleis-rest-client";

@Component({
  selector: 'ps-create-contact',
  templateUrl: 'create-contact.component.html'
})
export class CreateContactComponent implements OnInit {
  contact: SupplierContact;

  constructor(private bs: MatBottomSheetRef, private service: SupplierContactsService) {
    this.contact = {
      firstName: '',
      lastName: ''
    };
  }

  ngOnInit() {

  }

  save() {
    this.bs.dismiss(this.contact);
  }

  dismiss() {
    this.bs.dismiss(null);
  }

}
